// import React, { ReactNode, useState } from 'react';
// import axios from 'axios';
// import '../Pincodefinder/Style.css';
// import '../Pincodefinder/Track.css';
// import Tab from 'react-bootstrap/Tab';
// import '../Pincodefinder/Style.css';
// import '../Steelcity/css/style.css';
// import '../Steelcity/css/bootstrap.min.css';
// import '../Steelcity/css/responsive.css';
// import Tabs from 'react-bootstrap/Tabs';
// import Logo from '../Logo/RajAirlogo.png';

// interface TempodEntry {
//     EntryDate: string;
//     EntryTime: string;
//     Details: string;
//     Remark: string;
// }

// interface TrackingRecord {
//     CNoteNo: string;
//     InvoiceNo: string;
//     ExptDateDelivery: string;
//     VendorAwbNo: string;
//     bookdate: string;
//     ConsigneeName: string;
//     Status: string;
//     qty: string;
//     Destination_Name: string;
//     Origin_Name: string;
//     Mode: string;
//     recvName: string;
//     statusDt: string;
//     delvTime: string;
//     remark: ReactNode;
//     tempodData: TempodEntry[];
//     ImageLink: string;
// }

// const RajAirTracking: React.FC = () => {
//     const [searchValue, setSearchValue] = useState('');
//     const [trackingData, setTrackingData] = useState<TrackingRecord[]>([]);
//     const [showImage, setShowImage] = useState(false);
//     const [error, setError] = useState('');
//     const [currentStep, setCurrentStep] = useState(1);



//     const statusToStep: { [key: string]: number } = {
//         'Shipped': 1,
//         'In Transit': 2,
//         'Delivered': 3,
//     };

//     const handleButtonClick = () => {
//         setShowImage(!showImage); // Toggle the image visibility
//     };

//     const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//         const inputValue = e.target.value.slice(0, 200);
//         setSearchValue(inputValue);
//         setError('');
//         setTrackingData([]);
//     };

//     const fetchData = async () => {
//         try {
//             if (searchValue.trim() === '') {
//                 setError('Please enter one or more tracking numbers separated by commas.');
//                 return;
//             }

//             // const CNoteNo = searchValue.split(',').map(awb => awb.trim());
//             // const res = await axios.post('https://rajairexpress.com/RajAirTrackingApi/getTrackingData', { CNoteNo });
//             // const data = res.data;

//             // console.log(data, "Response from API");

//             const CNoteNo = searchValue.split(',').map(awb => awb.trim()).join(',');
//             const url = `https://rajairexpress.com/RajAirTrackingApi/getTrackingData?CNoteNo=${CNoteNo}`;

//             const res = await axios.get(url);
//             const data = res.data;

//             console.log(data, "Response from API");


//             if (data.status === 1 && data.Data) {
//                 const updatedData = data.Data.map((item: TrackingRecord) => {
//                     const imageId = item.CNoteNo; // Assuming CNoteNo is used for image URL
//                     item.ImageLink = `https://rajairexpress.com/portalapi/PODIMAGE/${imageId}.jpg`; // Create the image URL
//                     return item; // Return the updated item
//                 });

//                 setTrackingData(updatedData); // Update state with the modified data including ImageLink
//                 setError('');

//                 // Update the currentStep based on the status of the first record
//                 if (updatedData.length > 0) {
//                     const status = updatedData[0].Status; // Assuming status is relevant for the first record
//                     setCurrentStep(statusToStep[status] || 1); // Default to step 1 if status is unknown
//                 }
//             } else {
//                 setError('Docket Not Found');
//             }
//         } catch (error) {
//             console.error('Error:', error);
//             setError('Failed to fetch data. Please check your internet connection.');
//         }
//     };

//     return (
//         <>



//             <header className="navbarheader-fluid">
//                 {/* Top Marquee */}
//                 <div style={{ backgroundColor: '#08386bff', color: 'white', padding: '10px', textAlign: 'center', fontWeight: 'bold' }}>
//                     Welcome to Raj Air Express Cargo Pvt. Ltd. | +91 8424038717 - raju@rajairexpress.com
//                 </div>


//                 {/* Desktop Navbar */}
//                 <div className="navbar-container d-none d-lg-flex">
//                     <div className="navbar-logo">
//                         <img
//                             src={Logo}
//                             alt="Company Logo"
//                             className="img-fluid"
//                             style={{ height: "100px", width: "auto", marginTop: "-20px" }}
//                         />
//                     </div>

//                     <nav className="navbar-links">
//                         <a href="https://rajairexpress.com/">Home</a>
//                         <a href="https://rajairexpress.com/about-us.php">About Us</a>
//                         <a href="https://rajairexpress.com/portal/#/login">Branch_Login</a>
//                         <a href="https://rajairexpress.com/downloads.php">Document</a>
//                         <a href="https://rajairexpress.com/contact-us.php">Contact</a>
//                     </nav>
//                 </div>

//                 {/* Mobile Navbar (Offcanvas) */}
//                 <nav className="navbar bg-light fixed-top d-lg-none">
//                     <div className="container-fluid">
//                         {/* Left-side hamburger button */}
//                         <button
//                             className="navbar-toggler me-2"
//                             type="button"
//                             data-bs-toggle="offcanvas"
//                             data-bs-target="#offcanvasNavbar"
//                             aria-controls="offcanvasNavbar"
//                         >
//                             <span className="navbar-toggler-icon"></span>
//                         </button>

//                         {/* Brand Logo (on the right) */}
//                         <a className="navbar-brand ms-auto" href="#">
//                             <img
//                                 src={Logo}
//                                 alt="Company Logo"
//                                 style={{ height: "50px", width: "auto" }}
//                             />
//                         </a>

//                         {/* Offcanvas Menu (opens from left) */}
//                         <div
//                             className="offcanvas offcanvas-start"
//                             tabIndex={-1}
//                             id="offcanvasNavbar"
//                             aria-labelledby="offcanvasNavbarLabel"
//                         >
//                             <div className="offcanvas-header">
//                                 <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
//                                     Menu
//                                 </h5>
//                                 <button
//                                     type="button"
//                                     className="btn-close"
//                                     data-bs-dismiss="offcanvas"
//                                     aria-label="Close"
//                                 ></button>
//                             </div>

//                             <div className="offcanvas-body">
//                                 <ul className="navbar-nav justify-content-end flex-grow-1 pe-3">
//                                     <li className="nav-item">
//                                         <a href="https://rajairexpress.com/">Home</a>
//                                     </li>
//                                     <li className="nav-item">
//                                         <a href="https://rajairexpress.com/about-us.php">About Us</a>
//                                     </li>
//                                     <li className="nav-item">
//                                         <a href="https://rajairexpress.com/portal/#/login">Branch_Login</a>
//                                     </li>
//                                     <li className="nav-item">
//                                         <a href="https://rajairexpress.com/downloads.php">Document</a>
//                                     </li>
//                                     <li className="nav-item">
//                                         <a href="https://rajairexpress.com/contact-us.php">Contact</a>
//                                     </li>
//                                 </ul>
//                             </div>
//                         </div>
//                     </div>
//                 </nav>
//             </header>






//             <div className="container">
//                 <div className="row">
//                     <div className="col-lg-8">
//                         <h5 className='BLuedarttracking'><b> Raj Air Tracking Details</b></h5>

//                         {trackingData.length > 0 ? (
//                             trackingData.map((record, index) => (
//                                 <div key={index} className="shadow p-4 mb-4">
//                                     <table className="table table-bordered table-sm mb-4">
//                                         <thead>
//                                             <tr>
//                                                 <th>Waybill No</th>
//                                                 <th>Invoice No</th>
//                                                 <th>Expt Date of Delivery</th>
//                                                 <th>Status</th>
//                                                 <th>Date of Delivery</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             <tr>
//                                                 <td>{record.CNoteNo}</td>
//                                                 <td>{record.InvoiceNo}</td>
//                                                 <td>{record.ExptDateDelivery}</td>
//                                                 <td>{record.Status}</td>
//                                                 <td>{record.statusDt}</td>
//                                             </tr>
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             ))
//                         ) : (
//                             <div>No tracking data available.</div>
//                         )}

//                         <div className="steps-container">
//                             {[1, 2, 3].map(number => (
//                                 <span key={number} className="step-container">
//                                     {number > 1 && <div className="line"></div>}
//                                     <span className={`step-circle ${number <= currentStep ? 'active' : ''}`}>
//                                         {number}
//                                     </span>
//                                     <span className="step-label">{number === 1 ? 'Shipped' : number === 2 ? 'In Transit' : 'Delivered'}</span>
//                                 </span>
//                             ))}
//                             <div className="progress-bar-container">
//                                 <span
//                                     className="progress-indicator"
//                                     style={{ width: `${((currentStep - 1) / 2) * 100}%` }} // Adjusted to 2 for 3 steps
//                                 ></span>
//                             </div>
//                         </div>



//                     </div>

//                     <div className="col-lg-4">
//                         <div className="shadow p-4">
//                             <h1><b className='Track'>TRACK</b></h1>
//                             <div className="centered-input-container">
//                                 <input
//                                     type="text"
//                                     className="form-control mb-3 centered-input"
//                                     placeholder="Tracking Number(s)"
//                                     value={searchValue}
//                                     onChange={handleInputChange}
//                                 />
//                             </div>
//                             <button onClick={fetchData} className="Tracking">TRACK</button>
//                             {error && <div className="text-danger mt-2">{error}</div>}
//                             <p className="mt-2">To track multiple waybills, enter tracking numbers separated by commas.</p>
//                         </div>
//                     </div>
//                 </div>
//             </div >
//             <div className="container">
//                 <div className="row justify-content-start">  {/* ✅ ensures no center alignment */}
//                     <div className="col-lg-8 col-md-10 col-sm-12">
//                         <Tabs
//                             defaultActiveKey="details"
//                             id="uncontrolled-tab-example"
//                             className="custom-tabs"
//                         >
//                             <Tab eventKey="details" title="Shipment Details">
//                                 {trackingData.length > 0 ? (
//                                     trackingData.map((record, index) => (
//                                         <div key={index} className="shadow p-4 mb-3">
//                                             <div className="shipment-details">
//                                                 <div className="detail-row">
//                                                     <span className="detail-label">Waybill No:</span>
//                                                     <span className="detail-value">{record.CNoteNo}</span>
//                                                 </div>
//                                                 <div className="detail-row">
//                                                     <span className="detail-label">Forwarding No:</span>
//                                                     <span className="detail-value">{record.VendorAwbNo}</span>
//                                                 </div>
//                                                 <div className="detail-row">
//                                                     <span className="detail-label">Pickup Date:</span>
//                                                     <span className="detail-value">{record.bookdate}</span>
//                                                 </div>
//                                                 {/* <div className="detail-row">
//                           <span className="detail-label">Mode:</span>
//                           <span className="detail-value">{record.Mode}</span>
//                         </div> */}
//                                                 <div className="detail-row">
//                                                     <span className="detail-label">From:</span>
//                                                     <span className="detail-value">{record.Origin_Name}</span>
//                                                 </div>
//                                                 <div className="detail-row">
//                                                     <span className="detail-label">To:</span>
//                                                     <span className="detail-value">{record.Destination_Name}</span>
//                                                 </div>
//                                                 <div className="detail-row">
//                                                     <span className="detail-label">Status:</span>
//                                                     <span className="detail-value">{record.Status}</span>
//                                                 </div>
//                                                 <div className="detail-row">
//                                                     <span className="detail-label">Date of Delivery:</span>
//                                                     <span className="detail-value">{record.statusDt}</span>
//                                                 </div>
//                                                 <div>

//                                                     <button className="btn btn-success" onClick={handleButtonClick}>
//                                                         {showImage ? 'Hide Image' : 'Pod Image'}
//                                                     </button>
//                                                     {showImage && (
//                                                         <div className="image-container mt-2">

//                                                             {trackingData.length > 0 && (
//                                                                 <img src={trackingData[0].ImageLink} alt="Tracking" className="img-fluid" />
//                                                             )}
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     ))
//                                 ) : (
//                                     <div>No shipment details available.</div>
//                                 )}
//                             </Tab>

//                              <Tab eventKey="status" title="Status and Scans" className="tab-center">
//                                 {trackingData.length > 0 ? (
//                                     trackingData.map((record, index) => (
//                                         <div key={index}>
//                                             <p><b className='BLuedarttracking'>Status and Scans</b></p>
//                                             <div className="scrollable-table">
//                                                 <table className="table table-bordered table-sm">
//                                                     <thead className='background'>
//                                                         <tr>
//                                                             <th>Location</th>
//                                                             <th>Status</th>
//                                                             <th>Date</th>
//                                                             <th>Time</th>
//                                                         </tr>
//                                                     </thead>
//                                                     <tbody>
//                                                         {record.tempodData && record.tempodData.length > 0 ? (
//                                                             record.tempodData.map((entry, idx) => (
//                                                                 <tr key={idx}>
//                                                                     <td>{entry.Details}</td>
//                                                                     <td>{entry.Remark}</td>
//                                                                     <td>{entry.EntryDate}</td>
//                                                                     <td>{entry.EntryTime}</td>
//                                                                 </tr>
//                                                             ))
//                                                         ) : (
//                                                             <tr>
//                                                                 <td colSpan={4}>No scans available.</td>
//                                                             </tr>
//                                                         )}
//                                                     </tbody>
//                                                 </table>
//                                             </div>
//                                         </div>
//                                     ))
//                                 ) : (
//                                     <div>No status and scans available.</div>
//                                 )}
//                             </Tab>
//                         </Tabs>
//                     </div>
//                 </div>
//             </div>




//             <footer className="Rajair">
//                 <div className="container">
//                     <div className="row">
//                         {/* === Logo + About === */}
//                         <div className="col-lg-3 col-md-6 mb-4">
//                             <div className="footer-col">
//                                 <div>
//                                     <img
//                                         src={Logo}
//                                         alt="Company Logo"
//                                         className="footer-logo img-fluid"
//                                     />
//                                 </div>
//                                 <p>
//                                     As a privately owned company, we are a highly focused and capable logistics specialist with a strong global presence and extensive agency representation across most countries.
//                                     At <strong>RAJ AIR EXPRESS CARGO PVT. LTD. – WORLD WIDE LOGISTICS</strong>, client satisfaction is our top priority.
//                                     We are committed to delivering reliable, efficient, and tailored solutions every time.
//                                 </p>
//                                 <div className="social-icons">
//                                     <a href="#"><i className="fab fa-instagram"></i></a>
//                                     <a href="#"><i className="fab fa-facebook"></i></a>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* === Quick Links === */}
//                         <div className="col-lg-3 col-md-6 mb-4">
//                             <div className="footer-col">
//                                 <h4>Quick Links</h4>
//                                 <ul>
//                                     <li><a href="https://rajairexpress.com/">Home</a></li>
//                                     <li><a href="https://rajairexpress.com/about-us.php">About Us</a></li>
//                                     <li><a href="https://rajairexpress.com/RajAirTracking/">Track Shipment</a></li>
//                                     <li><a href="https://rajairexpress.com/standard-conditions.php">Standard Conditions of Carriage</a></li>
//                                     <li><a href="https://rajairexpress.com/downloads.php">Downloads</a></li>
//                                     <li><a href="https://rajairexpress.com/blog.php">Blog</a></li>
//                                     <li><a href="https://rajairexpress.com/faq.php">FAQ's</a></li>
//                                     <li><a href="https://rajairexpress.com/contact-us.php">Contact Us</a></li>
//                                     <li><a href="https://rajairexpress.com/privacy-policy.php">Privacy Policy</a></li>
//                                     <li><a href="https://rajairexpress.com/payment-terms.php">Payment Terms and Conditions</a></li>
//                                 </ul>
//                             </div>
//                         </div>

//                         {/* === Services === */}
//                         <div className="col-lg-3 col-md-6 mb-4">
//                             <div className="footer-col">
//                                 <h4>Our Services</h4>
//                                 <ul>
//                                     <li>International Document</li>
//                                     <li>International Non-Document</li>
//                                     <li>Food Items</li>
//                                     <li>Medicines</li>
//                                     <li>Ecommerce Logistics</li>
//                                     <li>CSB 5</li>
//                                     <li>B2B</li>
//                                     <li>B2C</li>
//                                     <li><a href="https://rajairexpress.com/services.php">View More</a></li>
//                                 </ul>
//                             </div>
//                         </div>

//                         {/* === Contact Info === */}
//                         <div className="col-lg-3 col-md-6 mb-4">
//                             <div className="footer-col">
//                                 <h4>Get in Touch</h4>
//                                 <p>
//                                     Shop No 2,3 Kunji Raman Chawl Parsiwada Opp. Airport Authority Of India Sahar Road,<br />
//                                     Andheri E, Mumbai - 400099
//                                 </p>
//                                 <p>
//                                     <strong>Phone:</strong> +91 8424038717 / +91 8424038718 / +91 8347321111<br />
//                                     <strong>Email:</strong> <a href="mailto:raju@rajairexpress.com">raju@rajairexpress.com</a>
//                                 </p>
//                             </div>
//                         </div>
//                     </div>

//                     {/* === Footer Bottom === */}
//                     <div className="footer-bottom text-center pt-3 mt-3 border-top border-secondary">
//                         <p className="mb-1">
//                             © 2025 Raj Air Express Cargo Pvt. Ltd. All Rights Reserved.
//                         </p>
//                         <div className="footer-links">
//                             <a href="https://rajairexpress.com/privacy-policy.php">Privacy & Policy</a>
//                             <span className="mx-2">|</span>
//                             <a href="https://rajairexpress.com/payment-terms.php">Terms and Conditions</a>
//                         </div>
//                     </div>
//                 </div>
//             </footer>

//         </>
//     );
// };

// export default RajAirTracking




import React, { ReactNode, useState } from 'react';
import axios from 'axios';
// @ts-ignore: allow importing CSS without a type declaration
import '../Tracking/PacifixTracking.css';
import Logo from '../Logo/RajAirlogo.png';
import Swal from "sweetalert2";

interface TempodEntry {
    EntryDate: string;
    EntryTime: string;
    Details: string;
    Remark: string;
}

interface TrackingRecord {
    CNoteNo: string;
    InvoiceNo: string;
    ExptDateDelivery: string;
    VendorAwbNo: string;
    bookdate: string;
    ConsigneeName: string;
    Status: string;
    qty: string;
    Destination_Name: string;
    Origin_Name: string;
    Mode: string;
    recvName: string;
    statusDt: string;
    delvTime: string;
    remark: ReactNode;
    tempodData: TempodEntry[];
    ImageLink: string;
}

const RajAirTracking = (): JSX.Element => {
    const [searchValue, setSearchValue] = useState('');
    const [trackingData, setTrackingData] = useState<TrackingRecord[]>([]);
    const [showImage, setShowImage] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [error, setError] = useState('');

    const handleButtonClick = () => {
        setShowImage(!showImage);
    };

    // const fetchData = async () => {
    //     try {
    //         if (!searchValue.trim()) {
    //             Swal.fire({
    //                 icon: "warning",
    //                 title: "Enter AWB Number",
    //                 text: "📩 Please enter AWB No to get tracking details",
    //             });
    //             return;
    //         }

    //         const url = `https://rajairexpress.com/RajAirTrackingApi/getTrackingData?CNoteNo=${searchValue}`;
    //         const res = await axios.get(url);

    //         if (res.data.status === 1) {
    //             setTrackingData(res.data.Data);

    //             setSearchValue("");   // 🔥 input clear here

    //             Swal.fire({
    //                 icon: "success",
    //                 title: "Tracking Found",
    //                 timer: 1200,
    //                 showConfirmButton: false,
    //             });

    //         } else {
    //             Swal.fire({
    //                 icon: "error",
    //                 title: "No Data Found",
    //             });
    //         }

    //     } catch {
    //         Swal.fire({
    //             icon: "error",
    //             title: "Error fetching data",
    //         });
    //     }
    // };


    const fetchData = async () => {
    try {
        if (!searchValue.trim()) {
            Swal.fire({
                icon: "warning",
                title: "Enter AWB Number",
                text: "📩 Please enter AWB No to get tracking details",
            });
            return;
        }

        // 🔥 AUTO DETECT (CNote vs RefNo)
        let url = "";

        if (searchValue.length >= 10) {
            // 👉 Vendor AWB (refNo)
            url = `https://rajairexpress.com/RajAirTrackingApi/getTrackingData?refNo=${searchValue}`;
        } else {
            // 👉 CNote
            url = `https://rajairexpress.com/RajAirTrackingApi/getTrackingData?CNoteNo=${searchValue}`;
        }

        const res = await axios.get(url);

        if (res.data.status === 1) {
            setTrackingData(res.data.Data);

            setSearchValue("");

            Swal.fire({
                icon: "success",
                title: "Tracking Found",
                timer: 1200,
                showConfirmButton: false,
            });

        } else {
            Swal.fire({
                icon: "error",
                title: "No Data Found",
            });
        }

    } catch {
        Swal.fire({
            icon: "error",
            title: "Error fetching data",
        });
    }
};
    return (

        <>

            <header className="navbarheader-fluid">

                {/* TOP BAR */}
                <div className="top-bar">
                    Welcome to Raj Air Express Cargo Pvt. Ltd. | +91 8424038717 - raju@rajairexpress.com
                </div>

                {/* DESKTOP NAVBAR */}
                <div className="navbar-container d-none d-lg-flex">

                    <div className="navbar-logo">
                        <img src={Logo} alt="logo" />
                    </div>

                    <nav className="navbar-links">
                        <a href="https://rajairexpress.com/">Home</a>
                        <a href="https://rajairexpress.com/about-us.php">About Us</a>
                        <a href="https://rajairexpress.com/services/international-document">Services</a>
                        <a href="https://rajairexpress.com/portal/#/login">Branch Login</a>
                        <a href="https://rajairexpress.com/downloads.php">Document</a>
                        <a href="https://rajairexpress.com/contact-us.php">Contact</a>
                    </nav>

                </div>

                {/* MOBILE NAVBAR */}
                <nav className="navbar bg-light fixed-top d-lg-none">
                    <div className="container-fluid">

                        {/* MENU BUTTON */}
                        <button
                            className="navbar-toggler"
                            type="button"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasNavbar"
                        >
                            <span className="navbar-toggler-icon"></span>
                        </button>

                        {/* LOGO */}
                        <a className="navbar-brand ms-auto" href="#">
                            <img src={Logo} alt="logo" />
                        </a>

                        {/* SIDEBAR MENU */}
                        <div className="offcanvas offcanvas-start" id="offcanvasNavbar">
                            <div className="offcanvas-header">
                                <h5>Menu</h5>
                                <button className="btn-close" data-bs-dismiss="offcanvas"></button>
                            </div>

                            <div className="offcanvas-body">
                                <ul className="navbar-nav">

                                    <li><a href="https://rajairexpress.com/">Home</a></li>
                                    <li><a href="https://rajairexpress.com/about-us.php">About Us</a></li>
                                    <li><a href="https://rajairexpress.com/services/international-document">Services</a></li>
                                    <li><a href="https://rajairexpress.com/portal/#/login">Branch Login</a></li>
                                    <li><a href="https://rajairexpress.com/downloads.php">Document</a></li>
                                    <li><a href="https://rajairexpress.com/contact-us.php">Contact</a></li>

                                </ul>
                            </div>
                        </div>

                    </div>
                </nav>

            </header>
            <div className="tracking-container">

                <div className="tracking-wrapper">

                    <h2 className="title">
                        Track a Shipment <span className="truck-icon">🚚</span>
                    </h2>

                    <p className="subtitle">
                        ⓘ Enter AWB Numbers in a separate line for advanced Tracking
                    </p>

                    <div className="input-box">
                        <input
                            type="text"
                            value={searchValue}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                setSearchValue(e.target.value)
                            }
                            placeholder="Enter AWB Number"
                        />
                    </div>

                    <div className="btn-group">
                        <button className="track-btn" onClick={fetchData}>
                            TRACK
                        </button>

                        <button
                            className="clear-btn"
                            onClick={() => setSearchValue("")}
                        >
                            CLEAR
                        </button>
                    </div>

                </div>

                {error && <p className="error">{error}</p>}

                {trackingData.length > 0 && (
                    <div className="result-section">

                        <div className="grid">

                            {/* LEFT */}
                            <div className="card">
                                <div className="card-header">Shipment Details</div>

                                <table className="shipment-table">
                                    <tbody>

                                        <tr>
                                            <td className="label">AWB No.</td>
                                            <td>{trackingData?.[0]?.CNoteNo}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Booking Date</td>
                                            <td>{trackingData?.[0]?.bookdate}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Consignee</td>
                                            <td>{trackingData?.[0]?.ConsigneeName}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Destination</td>
                                            <td>{trackingData?.[0]?.Destination_Name}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Tracking Number</td>
                                            <td>{trackingData?.[0]?.VendorAwbNo}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Delivery Status</td>
                                            <td>{trackingData?.[0]?.Status}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Delivery Date</td>
                                            <td>{trackingData?.[0]?.statusDt}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Receiver Name</td>
                                            <td>{trackingData?.[0]?.recvName}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Delivery Remark</td>
                                            <td>{trackingData?.[0]?.remark || '-'}</td>
                                        </tr>

                                        {/* POD IMAGE */}
                                        <tr>
                                            <td className="label">Pod Image</td>
                                            <td>
                                                <div className="pod-wrapper">

                                                    <button className="btn btn-success btn-sm" onClick={handleButtonClick}>
                                                        {showImage ? 'Hide Image' : 'Pod Image'}
                                                    </button>

                                                    {showImage && (
                                                        <div className="image-container mt-2">
                                                            {trackingData?.[0]?.ImageLink ? (
                                                                <>
                                                                    <img
                                                                        src={trackingData[0].ImageLink}
                                                                        alt="POD"
                                                                        className="pod-img"
                                                                        onClick={() => setShowModal(true)}
                                                                        onError={(e) => {
                                                                            (e.target as HTMLElement).style.display = "none";
                                                                        }}
                                                                    />

                                                                    {showModal && (
                                                                        <div
                                                                            className="pod-modal"
                                                                            onClick={() => setShowModal(false)}
                                                                        >
                                                                            <img
                                                                                src={trackingData[0].ImageLink}
                                                                                className="pod-modal-img"
                                                                                alt="Full POD"
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <div className="no-image-box">No Image Available</div>
                                                            )}
                                                        </div>
                                                    )}

                                                </div>
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>

                            {/* RIGHT */}
                            <div className="card">
                                <div className="card-header">Shipping History</div>

                                <table>
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Time</th>
                                            <th>Location</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {trackingData?.[0]?.tempodData?.length > 0 ? (
                                            trackingData[0].tempodData.map((item, i) => (
                                                <tr key={i}>
                                                    <td>{item.EntryDate}</td>
                                                    <td>{item.EntryTime}</td>
                                                    <td>{item.Details}</td>
                                                    <td>{item.Remark}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={4}>No Data Available</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                )} <br />

                {/* FOOTER */}
                <footer className="footer-light">
                    <div className="footer-container-fluid">

                        <div className="footer-grid">

                            {/* COLUMN 1 */}
                            <div className="footer-box">
                                <h3>Raj Air Express Cargo Pvt.Ltd.</h3>

                                <h4>Mumbai (Head Office)</h4>
                                <p>
                                    As a privately owned company, we are a highly focused and capable logistics specialist with a strong global presence and extensive agency representation across most countries. At RAJ AIR EXPRESS CARGO PVT. LTD. – WORLD WIDE LOGISTICS, client satisfaction is our top priority. We are committed to delivering reliable, efficient, and tailored solutions every time.
                                </p>
                            </div>

                            {/* COLUMN 2 */}
                            <div className="footer-box">
                                <h3>Raj Air Express Cargo Pvt.Ltd</h3>

                                <h4>Mumbai (Office)</h4>
                                <p>
                                    Shop No 2,3 Kunji Raman Chawl Parsiwada Opp. Airport Authority Of India...
                                </p>

                                <p>📞 +91 8424038717</p>
                                <p>📞 +91 8424038718</p>
                                <p>📞 +91 8347321111</p>
                                <p>✉ raju@rajairexpress.com</p>
                            </div>

                            {/* COLUMN 3 */}
                            <div className="footer-box">
                                <h3>SERVICES</h3>
                                <ul className="services-list">
                                    <li>Express Courier</li>
                                    <li>E-Commerce</li>
                                    <li>General Cargo</li>
                                    <li>Nominated Shipments</li>
                                    <li>Airline Consolidation</li>
                                    <li>Door to Door Cargo</li>
                                    <li>Dangerous Goods</li>
                                    <li>Cross Border Business</li>
                                    <li>Custom Brokerage</li>
                                </ul>
                            </div>

                            {/* ✅ NEW COLUMN 4 */}
                            <div className="footer-box">
                                <h3>QUICK LINKS</h3>
                                <ul className="services-list">
                                    <li>Home</li>
                                    <li>About Us</li>
                                    <li>Tracking</li>
                                    <li>Contact</li>
                                    <li>Privacy Policy</li>
                                    <li>Standard Conditions of Carriage</li>
                                    <li>Payment Terms and Conditions</li>
                                    <li>International Document</li>
                                    <li>Food Items</li>
                                    <li>Ecommerce Logistics</li>

                                </ul>
                            </div>

                        </div>

                    </div>
                </footer>
                <div className="footer-bottom">
                    <div className="footer-bottom-container">

                        <div className="footer-left">
                            © 2025 Raj Air Express Cargo Pvt. Ltd. All Rights Reserved.
                        </div>

                        <div className="footer-right">
                            <a href="#">Privacy & Policy</a>
                            <a href="#">Terms and Conditions</a>
                        </div>

                    </div>
                </div>

            </div>
        </>





    );
};

export default RajAirTracking;